import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { cacheSungageApplicationHandoff } from "./useStartBatterySungageApplication"
import type { BatterySungageApplicationHandoffDto } from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Resume the same Sungage attempt. Never creates a replacement.
 */
export default function useResumeBatterySungageApplication(): UseMutationResult<
  BatterySungageApplicationHandoffDto,
  unknown,
  { proposalId: string; applicationId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId }) =>
      batteryProposalService.resumeSungageApplication(proposalId, applicationId),
    onSuccess: (handoff, { proposalId }) =>
      cacheSungageApplicationHandoff(queryClient, proposalId, handoff),
  })
}
